import { GetStaticProps, NextPage } from 'next'
import ContactsPageMain from '../components/ContactsPageMain/ContactsPageMain'
import { HeaderColors } from '../components/types'
import { initializeApollo } from '../lib/apolloClient'
import { createContacts } from '../lib/createContacts'
import { createPageSeo, getPageSeo } from '../lib/createPageSeo'
import globalCache from '../lib/globalCache'
import { CONTACTS } from '../queries/contacts'
import { contacts, contactsVariables } from '../__generated__/contacts'

const ContactsPage: NextPage<{ data: contacts }> = ({ data }) => {
  const contacts = createContacts(data)

  return <ContactsPageMain contacts={contacts} />
}

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo()
  await globalCache(apolloClient)

  let seo

  const [data, seoData] = await Promise.all([
    apolloClient.query<contacts, contactsVariables>({
      query: CONTACTS,
      variables: {
        contactsWhere: {
          iblock: { code: { equals: 'shops' } },
          code: { equals: 'shourum-km-cosmetics' },
          active: { equals: true },
        },
        contactsPropsWhere: {
          OR: [
            { property: { code: { contains: 'PHONE' } } },
            { property: { code: { equals: 'EMAIL' } } },
            { property: { code: { equals: 'COORDS' } } },
          ],
        },
        settingsPlusWhere: {
          OR: [
            { code: { equals: 'UF_CONTACTS_INDEX' } },
            { code: { equals: 'UF_CONTACTS_ADDRESS' } },
            { code: { equals: 'UF_CONTACTS_WORK_HOURS' } },
            { code: { equals: 'UF_MESSENGER_WA' } },
            { code: { equals: 'UF_MESSENGER_TG' } },
          ],
        },
      },
    }),
    getPageSeo(apolloClient, 'contacts-page'),
  ])

  if (seoData?.data?.element) {
    seo = createPageSeo(seoData.data)
  }

  return {
    props: {
      __APOLLO_STATE__: apolloClient.cache.extract(),
      headerInitColor: HeaderColors.black,
      data: data?.data,
      seo,
    },
    revalidate: 60,
  }
}

export default ContactsPage
